import { Fragment } from 'react';
import { useSubPath } from '../../app/useSubPath';
import { ExerciseRunner } from '../exercise/ExerciseRunner';
import { LessonPage } from '../lesson/LessonPage';
import { challengeCards, challengeConfig } from '../levels';
import { GroupTitle, LessonList, LevelGrid, ModulePage, type TabDef } from '../module/ModulePage';
import { Explore } from './Explore';
import { CHALLENGES, EX_GROUPS, LEVELS, levelConfig } from './levels';

type Tab = 'dersler' | 'antrenman' | 'kesfet' | 'meydan';
const TABS: TabDef<Tab>[] = [
  { id: 'dersler', label: 'Dersler', icon: 'book' },
  { id: 'antrenman', label: 'Antrenman', icon: 'target' },
  { id: 'kesfet', label: 'Keşfet', icon: 'grid' },
  { id: 'meydan', label: 'Meydan okuma', icon: 'trophy' },
];

export function NotaSection() {
  const [sub, a, b] = useSubPath();
  if (sub === 'ders') return <LessonPage module="nota" id={a ?? ''} />;
  if (sub === 'egz') {
    const level = LEVELS.find((l) => l.group.id === a && String(l.n) === b);
    if (level) return <ExerciseRunner config={() => levelConfig(level)} />;
  }
  if (sub === 'meydan' && a) {
    const ch = CHALLENGES.find((c) => c.id === a);
    if (ch) return <ExerciseRunner config={() => challengeConfig('nota', ch)} />;
  }
  const tab: Tab = sub === 'antrenman' || sub === 'meydan' || sub === 'kesfet' ? sub : 'dersler';
  return (
    <ModulePage id="nota" levels={LEVELS} tabs={TABS} active={tab}>
      {tab === 'dersler' ? (
        <>
          <GroupTitle title="Önce öğren" sub="Müzik alfabesinden sapın haritasına, oradan kulakla nota tanımaya." />
          <LessonList module="nota" />
        </>
      ) : tab === 'antrenman' ? (
        EX_GROUPS.map((g) => (
          <Fragment key={g.id}>
            <GroupTitle title={g.title} sub={g.sub} />
            <LevelGrid items={g.levels} />
          </Fragment>
        ))
      ) : tab === 'kesfet' ? (
        <Explore />
      ) : (
        <>
          <GroupTitle title="Meydan okumalar" sub="Hız ve isabet. Rekorların saklanır." />
          <LevelGrid items={challengeCards(CHALLENGES)} />
        </>
      )}
    </ModulePage>
  );
}
